export default __webpack_public_path__ + "static/media/main.944cf4fe.png";